import * as React from 'react';
import { CerebroText } from './CerebroText';
import { CerebroIcon } from './CerebroIcon';
import { Typography, TypographyProps, useTheme, IconButton } from '@mui/material';

interface CerebroLabelProps extends Omit<TypographyProps, 'variant' | 'component' | 'ref'> {
	htmlFor?: string;
	size?: 'small' | 'large';
	error?: boolean;
	required?: boolean;
	icon?: React.ComponentType;
	onIconClick?: () => void;
	hint?: string;
}

export const CerebroLabel: React.FC<CerebroLabelProps> = ({
	htmlFor,
	size = 'large',
	error = false,
	required = false,
	icon: Icon = null,
	onIconClick,
	hint,
	children,
	...props
}) => {
	const theme = useTheme();

	const variant = size === 'small' ? 'labelSmall' : 'labelLarge';
	const color = error ? theme.palette.error.main : props.color;
	const showHint = required || hint;

	return (
		<Typography variant={variant} component="label" htmlFor={htmlFor} {...props} color={color}>
			{children}
			{showHint && (
				<CerebroText variant={error ? 'error' : 'hint'} component="span">
					&nbsp; ({hint ?? 'Required'})
				</CerebroText>
			)}

			{Icon && onIconClick != null && (
				<CerebroIcon padLeft>
					<IconButton onClick={onIconClick}>
						<Icon />
					</IconButton>
				</CerebroIcon>
			)}

			{Icon && onIconClick == null && (
				<CerebroIcon padLeft>
					<Icon />
				</CerebroIcon>
			)}
		</Typography>
	);
};
